import { useObservable } from "@rsm";
import { LoadingPage } from "components/LoadingPage/LoadingPage";
import { useMainNavigate } from "hooks/useMainNavigate";
import { useResultsModuleBLoC } from "modules/ResultsModule/ResultsModule.bloc";
import { ResultsModuleHelpers } from "modules/ResultsModule/ResultsModule.helpers";
import React, { useEffect } from "react";
import { Globals } from "types/globals";

export const ResultsLandingPage: React.FC<{}> = () => {
  const { project$, followUpQuestions$, segmentQuestion$ } = useResultsModuleBLoC();
  const project = useObservable(project$);
  const followUpQuestions = useObservable(followUpQuestions$);
  const segmentQuestion = useObservable(segmentQuestion$);
  const navigate = useMainNavigate();

  useEffect(() => {
    const navigateToResults = (route: string) => {
      navigate(ResultsModuleHelpers.internalResultsLink(project!.id, route), { replace: true });
    };

    switch (project?.projectType) {
      case "idea":
      case "message":
        if (project.frameworkId === Globals.Frameworks.PriceSensitivity) {
          navigateToResults("price-sensitivity");
        } else if (project.frameworkId === Globals.Frameworks.MarketReach) {
          navigateToResults("market-reach");
        } else {
          navigateToResults("all");
        }
        break;
      case "npd":
        navigateToResults("npd");
        break;
      case "question":
        if (segmentQuestion) {
          navigateToResults(`segment-question/${segmentQuestion.id}`);
          break;
        }
        if (followUpQuestions?.length) {
          const questionType =
            followUpQuestions[0]!.question.questionTypeId === Globals.QuestionType.text ? "text" : "qual";
          navigateToResults(`${questionType}/${followUpQuestions[0]!.id}`);
        }
        break;
      default:
        break;
    }
  }, [project, navigate, followUpQuestions, segmentQuestion]);
  return <LoadingPage />;
};
